class WdReviewSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-wd-review-slide]'));
    this.prevButton = this.querySelector('[data-wd-review-prev]');
    this.nextButton = this.querySelector('[data-wd-review-next]');
    this.label = this.querySelector('[data-wd-review-label]');
    this.index = 0;

    if (this.slides.length < 2) {
      if (this.slides.length === 1) {
        this.slides[0].hidden = false;
        this.slides[0].setAttribute('aria-hidden', 'false');
      }

      if (this.label && this.slides.length) {
        this.label.textContent = `1/${this.slides.length}`;
      }

      this.updatePagerState();
      return;
    }

    this.prevButton?.addEventListener('click', () => this.show(this.index - 1));
    this.nextButton?.addEventListener('click', () => this.show(this.index + 1));
    this.show(0);
  }

  show(nextIndex) {
    if (!this.slides.length) return;

    const total = this.slides.length;
    const index = Math.max(0, Math.min(nextIndex, total - 1));
    this.index = index;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.hidden = !isActive;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    if (this.label) {
      this.label.textContent = `${index + 1}/${total}`;
    }

    this.updatePagerState();
  }

  updatePagerState() {
    const total = this.slides.length;
    const hasMultiple = total > 1;

    if (this.prevButton) {
      this.prevButton.disabled = !hasMultiple || this.index === 0;
    }

    if (this.nextButton) {
      this.nextButton.disabled = !hasMultiple || this.index === total - 1;
    }
  }
}

if (!customElements.get('wd-review-slider')) {
  customElements.define('wd-review-slider', WdReviewSlider);
}
